import type { AutocompleteBody, AutocompleteParams } from "@apptus/esales-api";
import elevateClient from "@server/elevate";

import type { MarketConfiguration } from "@/config/markets/const";

import mapCustomAttributes from "./mapCustomAttributes";

export default async function getAutocomplete(
  market: MarketConfiguration,
  input: AutocompleteParams,
  config?: AutocompleteBody,
) {
  return elevateClient(market).query.autocomplete(
    {
      ...input,
      notify: process.env.NEXT_PUBLIC_ENVIRONMENT === "prod",
      presentCustom: mapCustomAttributes([], market),
      presentPrices: [
        `NG_${market.code.toLowerCase()}_best`,
        `NG_${market.code.toLowerCase()}_RRP`,
        `NG_${market.code.toLowerCase()}_pricematch`,
        `NG_${market.code.toLowerCase()}_campaign`,
      ],
      priceId: `NG_${market.code.toLowerCase()}_best`,
    },
    {
      contentLists: [
        {
          id: "designers",
          limit: 3,
          contentFilter: {
            type: ["designer"],
          },
        },
        {
          id: "brands",
          limit: 3,
          contentFilter: {
            type: ["brand"],
          },
        },
        {
          id: "categories",
          limit: 3,
          contentFilter: {
            type: ["category"],
          },
        },
      ],
      ...config,
    },
  );
}
